module.exports = __webpack_public_path__ + "img/background_2560.91ae756d.png";